import { FunctionComponent, useEffect, useState } from "react";
import { ReactSelectBox } from "client/CommonComponents";
import { AdminDropdown } from "../../utils/constant";
import "./header.style.scss";
import { useLocation, useNavigate } from "react-router-dom";

interface IProps {}

const Header: FunctionComponent<IProps> = () => {
  const [adminstration, setAdminstration] = useState<any>('');
  const navigate = useNavigate();

  const location = useLocation();
  const segments = location.pathname.split("/");
  const page = segments[segments.length - 1];

  useEffect(() => {
    if(page !== 'Administration'){
      let val = AdminDropdown?.find((item:any) => item.value === page)
      setAdminstration({label:val?.label ,value:page, text: page})
    }
  },[page])

  const handleChange = (admin:any) => {
    setAdminstration(admin);
    navigate('/Administration/'+admin.value)
  }

  return (
    <>
      <section className="Header-Container">
        <div className="flex">
          <span>Dashboard</span>
          <ReactSelectBox
              name="Adminstration"
              placeholder="Select Adminstration"
              className="admin-dropdown"
              onChange={handleChange}
              value={adminstration }
              options={AdminDropdown}
              isSearchable={true}
             data-attribute="index_Adminstration_SearchSelectBox" />
        </div>
      </section>
    </>
  );
};

export default Header;
